module.exports = __webpack_public_path__ + "c7dbf1d5f207b66f6d0940748831f953.svg";